<template>
  <div v-html="avatars.create(seed)" style="height:20px;width:20px;" />
</template>

<script>
import Avatars from "@dicebear/avatars";
import sprites from "@dicebear/avatars-jdenticon-sprites";
export default {
  data() {
    return { avatars: new Avatars(sprites, {}) };
  },
  props: ["seed"]
};
</script>

<style></style>
